import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Textfield, Button } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export const RemainingSeats = styled.div<{ noSeatsLeft: boolean }>`
    flex: 1 0 100%;
    align-self: flex-end;
    justify-content: flex-end;
    display: flex;
    line-height: 16px;
    margin-bottom: 4px;
    ${setFontVariant("caption")};
    color: ${({ noSeatsLeft }) => (noSeatsLeft ? colorsPalettes.red[400] : colorsPalettes.carbon[300])};
`;

export const EmailFieldContainer = styled(Flex)<{ isNoMoreSeatsLeft?: boolean }>`
    flex-direction: row;
    outline: 1px solid ${colorsPalettes.midnight[50]};
    flex: 1 0 100%;
    border-radius: 3px;

    ${({ isNoMoreSeatsLeft }) =>
        isNoMoreSeatsLeft &&
        `
        background-color: ${colorsPalettes.bluegrey[200]};
    `}

    &:has(input:focus) {
        outline: 1px solid ${colorsPalettes.blue[400]};
    }
`;

export const EmailField = styled(Textfield)<{ isNoMoreSeatsLeft?: boolean }>`
    flex: 1 0 80%;
    & .input-container[disabled] {
        background-color: white;
    }

    ${({ isNoMoreSeatsLeft }) =>
        isNoMoreSeatsLeft &&
        `
        & .input-container[disabled] {
            background-color:${colorsPalettes.bluegrey[200]};
        }
    `}
`;

export const UnknownDomain = styled.div`
    flex: 1 0 100%;
    color: ${colorsPalettes.red[400]};
    margin-top: 4px;
    ${setFontVariant("caption", colorsPalettes.red[400])}
    justify-content: flex-start;
    line-height: 20px;

    & span {
        color: ${colorsPalettes.carbon[300]};
    }
`;

export const SeatLimitReached = styled(UnknownDomain)`
    color: ${colorsPalettes.carbon[300]};
`;

export const EmailInputContainer = styled.div`
    display: flex;
    flex: 1 0 100%;
    flex-wrap: wrap;
    flex-direction: row;
    width: 100%;
`;

export const Messages = styled.div`
    flex: 1 0 100%;
    display: flex;
    height: 20px;
    max-height: 20px;
`;

export const AddButton = styled(Button)<{ isNoMoreSeatsLeft?: boolean }>`
    height: 38px;
    margin-top: 1px;
    margin-right: 8px;
    min-width: initial;
    ${({ isNoMoreSeatsLeft }) =>
        isNoMoreSeatsLeft &&
        `
        background-color: ${colorsPalettes.bluegrey[200]};
    `}
`;
